import { useNavigate } from '@tanstack/react-router';

import { Botao } from '../ds/Botao.js';
import { Vazio } from '../ds/Vazio.js';

export function NaoEncontrada() {
  const navegar = useNavigate();
  return (
    // `nivel={2}`, não `h1`: o `h1` desta tela é o do cabeçalho preso da
    // `Casca`, que fora das abas mostra o nome do app. Aqui o que se anuncia é
    // o que houve com o endereço, um degrau abaixo.
    //
    // Botão e não `Link` com cara de botão: o design system não tem link
    // estilizado, e emprestar a classe `.ds-botao` a uma âncora acoplaria as
    // duas coisas por fora, sem o componente saber. Num app instalado não há
    // o que se perca — abrir "Ir para Hoje" em outra aba não é caso de uso.
    // O título continua "Página não encontrada", e não o "Vamos voltar ao dia
    // de hoje." da prancha 15.3: lá essa frase é o corpo porque o cabeçalho
    // preso diz "Página não encontrada", e aqui o cabeçalho cai no mesmo
    // rótulo genérico de `/registrar` e `/ds` — trocar o fallback acertaria a
    // prancha nesta tela e erraria nas outras duas. O que a prancha pede de
    // forma e a tela ganhou: ícone, título equilibrado e a saída larga.
    <Vazio
      nivel={2}
      titulo="Página não encontrada"
      descricao="Este endereço não está disponível no aplicativo. Pode ser um atalho antigo da Tela de Início."
      acao={
        <Botao
          largura="cheia"
          onClick={() => {
            void navegar({ to: '/hoje' });
          }}
        >
          Ir para Hoje
        </Botao>
      }
    />
  );
}
